import { render } from "./GuideBar.vue?vue&type=template&id=965eb7b2&scoped=true"
import script from "./GuideBar.vue?vue&type=script&lang=js"
export * from "./GuideBar.vue?vue&type=script&lang=js"

import "./GuideBar.vue?vue&type=style&index=0&id=965eb7b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-965eb7b2"],['__file',"src/components/GuideBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "965eb7b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('965eb7b2', __exports__)) {
    api.reload('965eb7b2', __exports__)
  }
  
  module.hot.accept("./GuideBar.vue?vue&type=template&id=965eb7b2&scoped=true", () => {
    api.rerender('965eb7b2', render)
  })

}


export default __exports__